import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  title: "",
  sectionId: "",
  modalContent: "",
  banner: true,
};

const openInModalSlice = createSlice({
  name: "openInModal",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.banner = true;
      state.isOpen = true;
    },
    closeModal: (state, action) => {
      state.isOpen = false;
    },
    closeBanner: (state, action) => {
      state.banner = false;
    },
    updateTitle: (state, action) => {
      state.title = action.payload ?? "";
    },
    updateSectionId: (state, action) => {
      state.sectionId = action.payload ?? "";
    },
    updateModalContent: (state, action) => {
      state.modalContent = action.payload ?? "";
    },
  },
});

export const {
  closeBanner,
  closeModal,
  openModal,
  updateTitle,
  updateSectionId,
  updateModalContent,
} = openInModalSlice.actions;

export default openInModalSlice.reducer;
